module.exports = __webpack_public_path__ + "img/orderpacked.e2033e60.png";